
//Orange button popup
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography, Stack } from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";

export default function AlertDialog({
  open,
  title,
  message,
  btn_function,
  btn_Orange_Text,
  btn_link,
  btn_link_text,
}) {
  const [notClosed, setNotClosed] = React.useState(open);
  return (
    <Dialog
      // open={open}
      open={notClosed}
      // onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      // maxWidth='sm'
      maxWidth="md"
      sx={{
        color: "#ECF3FF",
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <Stack direction={"row"} spacing={2}>
          <Typography
            variant={"h6"}
            sx={{ flex: 1, textAlign: "left" }}
            color={"primary"}
          >
            {title}
          </Typography>
          <IconButton color={"primary"} onClick={() => setNotClosed(false)}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <br/>
        <DialogContentText variant={"body1"} id="alert-dialog-description">
         {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ paddingX: 3, paddingY: 2 }}>
        {btn_link && (
          <Button
            variant={"text"}
            align="right"
            sx={{ paddingX: 3, textDecoration: "underline" }}
            size={"small"}
            onClick={() => setNotClosed(false)}
          >
            {btn_link_text}
          </Button>
        )}
        <Button
          variant={"contained"}
          color={"warning"}
          align="right"
          sx={{ paddingX: 3, backgroundColor: "#FD4A01" }}
          size={"small"}
          onClick={btn_function===undefined ? ()=>setNotClosed(false) : btn_function}
        >
          {btn_Orange_Text}
        </Button>
      </DialogActions>
        
    </Dialog>
  );
}

AlertDialog.propTypes = {
  btn_link: PropTypes.bool,
};
AlertDialog.defaultProps = {
  btn_link: false,

};
